/**
 * Delays the execution of a callback by the provided delay time (ms).
 * Subsequent calls reset the timer.
 * @param callback The function to be executed when the timer runs out.
 * @param delay The time to wait before firing off the execution.
 * @param key A unique identifier which will be used to store debouncers under in memory (defaults to 'default')
 */
const timeoutsMap = new Map<string, NodeJS.Timeout>()

const debounce = (callback: (...params: any) => void, delay = 500, key: string = 'default') => {
  return function (...args: any) {
    const activeTimeout = timeoutsMap.get(key)

    if (activeTimeout) {
      clearTimeout(activeTimeout)
    }

    timeoutsMap.set(
      key,
      setTimeout(() => {
        // We know this works and have tests around it, but it is tricky
        // to satisfy the TS compiler when using apply
        // @ts-ignore
        callback.apply(this, args)

        if (activeTimeout) {
          clearTimeout(activeTimeout)
        }
      }, delay)
    )
  }
}

export default debounce
